<div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pb-12 tw-text-center tw-font-inter">
  <img class="no-events-img" [src]="getImageSrc()" alt="No events" />

  <div
    class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2"
    [ngClass]="{
      'tw-mb-6': showCreateButton() && mode() === 'all',
      'tw-max-w-[37rem]': mode() === 'all-archived'
    }"
  >
    <p class="tw-font-inter tw-text-xl {{getSubheading() ? 'tw-font-bold' : ''}} tw-text-gray-900">{{ getHeading() }}</p>
    @if (showSubheading()) {
      <p class="tw-font-inter tw-text-base tw-text-gray-500 tw-font-medium">{{ getSubheading() }}</p>
    }
  </div>

  @if (showCreateButton() && mode() === 'all' && canCreate()) {
    <button
      type="button"
      class="tw-font-inter tw-justify-center create-event-btn tw-px-6 tw-py-3 tw-rounded-lg tw-bg-blue-600 tw-text-white tw-text-base tw-font-medium hover:tw-bg-blue-700 tw-inline-flex tw-items-center tw-gap-2"
      (click)="onCreateClicked()"
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.1111 7.11111H8.88889V0.888889C8.88889 0.653141 8.79524 0.427048 8.62854 0.260349C8.46184 0.0936505 8.23575 0 8 0C7.76425 0 7.53816 0.0936505 7.37146 0.260349C7.20476 0.427048 7.11111 0.653141 7.11111 0.888889V7.11111H0.888889C0.653141 7.11111 0.427048 7.20476 0.260349 7.37146C0.0936505 7.53816 0 7.76425 0 8C0 8.23575 0.0936505 8.46184 0.260349 8.62854C0.427048 8.79524 0.653141 8.88889 0.888889 8.88889H7.11111V15.1111C7.11111 15.3469 7.20476 15.573 7.37146 15.7397C7.53816 15.9064 7.76425 16 8 16C8.23575 16 8.46184 15.9064 8.62854 15.7397C8.79524 15.573 8.88889 15.3469 8.88889 15.1111V8.88889H15.1111C15.3469 8.88889 15.573 8.79524 15.7397 8.62854C15.9064 8.46184 16 8.23575 16 8C16 7.76425 15.9064 7.53816 15.7397 7.37146C15.573 7.20476 15.3469 7.11111 15.1111 7.11111Z" fill="white"/>
      </svg>
      {{ createButtonLabel() }}
    </button>
  }
</div>
